import {CSSProperties, FC} from 'react';


export interface IIconGlobeProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconGlobe: FC<IIconGlobeProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Zm0 1.5c1.477 0 2.848.44 4.008 1.172l-.61.07.141 1.5-.797-.352-.656.563L14.203 9l1.617-.516 2.016.657-.515.938-1.22-.75-1.312.187-1.289.96-.727 2.25 1.454 1.195s1.49-.257 1.57-.257c.079 0 .633 1.359.633 1.359l-1.195 3.75a7.503 7.503 0 0 1-3.235.726c-.237 0-.472-.026-.704-.047l-.82-1.43.797-3L8.25 12.75H5.46l-.725-1.477L6.75 9.68l3-1.43-.445-1.992 1.289-.281.61.843 2.25-.422-.4-1.734-1.663-.117c.199-.015.403-.047.609-.047Zm-.844.047-1.172.492-.563-.093a7.401 7.401 0 0 1 1.735-.4v.001Zm-6.61 8.038.728.844v1.547l1.405 1.546h.867l2.134 2.626c-2.83-.917-4.896-3.48-5.133-6.563Z" />
        </svg>
    );
};
